import { analyticsUtils } from 'utils/analytics-utils';

// событие срабатывать при попадании каждого товара этого блока во viewport.

export const gaImpressionsProduct = ({
  name,
  id,
  price,
  position,
}: {
  name: string;
  id: string;
  price: string;
  position: string;
}) =>
  analyticsUtils.sendEvent('GA:impressions', {
    elementType: 'product',
    elementBlock: 'productDetail / calc', // блок, в котором расположен элемент
    elementName: 'Результат по размерам',
    productName: name, // название товара
    productId: id, // артикул товара
    productPrice: price, // стоимость единицы товара
    productPosition: position, // позиция товара в блоке при подсчете слева-направо от 1
    productBelong: 'LeroyMerlin', // принадлежность товара: LeroyMerlinMarketplace - для
  });
